import React from 'react';

import LazyImage from '../../lazyload/lazy-image/lazy-image.component';
import ModalSheet from '../modal-sheet/modal-sheet.component';
import { connect } from 'react-redux';
import { setIsInfoModalOpen } from '../../../../redux/modal/modal.actions';
import {
  getLocalizedDescription,
  getLocalizedTitle,
} from '../../../../utility/util/util.service';
import { useIntl } from 'react-intl';
import xss from 'xss';

const InfoModal = ({ isOpen, infoModalData, setIsInfoModalOpen }) => {
  const intl = useIntl();
  const closeModal = () => setIsInfoModalOpen(false);

  const customXss = new xss.FilterXSS({
    whiteList: {
      p: [],
      b: [],
      br: [],
      em: [],
      u: [],
      i: [],
      strong: [],
      ul: [],
      li: [],
    },
  });

  const description = getLocalizedDescription(infoModalData, intl.locale);
  const SanitizedHTML = ({ htmlContent }) => {
    const sanitizedHtml = customXss.process(htmlContent);

    return <div dangerouslySetInnerHTML={{ __html: sanitizedHtml }} />;
  };

  return (
    <ModalSheet isOpen={isOpen} closeModal={closeModal} title="Info">
      <div className="px-1">
        {infoModalData?.image && (
          <LazyImage
            image={infoModalData?.image}
            variant="menuEntry"
            className="img-cover-center card-img mt-0 mh-10 mb-1"
            placeholderContainerClassNames="h-10"
            placeholderClassNames="mh-10"
          />
        )}
        <span className="font-weight-bolder font-medium-2 text-dark mt-2 mb-2">
          {getLocalizedTitle(infoModalData, intl.locale)}
        </span>
        <SanitizedHTML htmlContent={description} />
      </div>
    </ModalSheet>
  );
};

const mapStateToProps = (state) => ({
  isOpen: state.modals.isInfoModalOpen,
  infoModalData: state.modals.infoModalData,
  store: state.store.store,
  me: state.me.me,
});

export default connect(mapStateToProps, { setIsInfoModalOpen })(InfoModal);
